import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(theme => ({
  root: {
    padding: "0",
  },

  close: {
    width: "40px",
    height: "40px",
    position: "relative",
    right: "-10px",
  },

  title: {
    textAlign: "left",
    color: theme.palette.brandPrimary,
    lineHeight: "4rem",
  },

  label: {
    fontStyle: "normal",
    fontSize: "1.6rem",
  },

  loadingIndicator: {
    position: "absolute",
    height: "100%",
    width: "100%",
    backgroundColor: theme.palette.secondary.dark,
  },
}));

const MediaDialog = props => {
  const {
    open,
    title,
    content,
    actions,
    loading,
    handleClose,
    titleClassName,
    contentClassName,
    actionsClassName,
    fullScreen,
    fullWidth,
    maxWidth,
  } = props;
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      {loading && (
        <div className={classes.loadingIndicator}>
          <PanelLoadingIndicator />
        </div>
      )}
      <DialogTitle>
        <Grid container justify="space-between" alignItems="center">
          <Typography
            variant="h4"
            classes={{ root: titleClassName || classes.title }}
          >
            {title}
          </Typography>
          <IconButton classes={{ root: classes.close }} onClick={handleClose}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: contentClassName || classes.content }}>
        {content}
      </DialogContent>
      <DialogActions classes={{ root: actionsClassName || classes.actions }}>
        {actions}
      </DialogActions>
    </Dialog>
  );
};

export default MediaDialog;
